export enum WssSubscriptionEventTypes {
    SUBSCRIPTION_ACTIVATED = "subscription_activated",
}

export interface WssSubscriptionActivatedPayload {
    event: WssSubscriptionEventTypes.SUBSCRIPTION_ACTIVATED;
    companyId: string;
}

export type WssSubscriptionPayload = WssSubscriptionActivatedPayload;
